<template>
  <div>
    <el-button type="primary" plain @click="dialogVisible= true" v-if="!(userMess.status==2||userMess.applyPost==2)">申请解锁</el-button>
    <div class="card mat10">
      <el-table :data="tableData" stripe style="width: 100%" @row-click="detail">
        <el-table-column :prop="item.prop" :label="item.label" :width="item.width" v-for="item in column" :key="item.prop">
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <un-lock :dialog-visible="dialogVisible" @on-close="closeDialog" @on-submit="getDialog" title="申请解锁展厅"></un-lock>
  </div>
</template>

<script>
import unLock from './components/modal.vue'
export default {
  components: {
    unLock
  },
  data() {
    return {
      tableData: [],
      column: [
        { prop: "exhibitionHallName", label: "展厅名称", width: "" },
        { prop: "exhibitionTypeName", label: "类型", width: 90 },
        { prop: "explainsAmount", label: "已讲解次数", width: "" },
        { prop: "explainsTime", label: "讲解时长", width: "" },
        { prop: "unlockTime", label: "解锁时间", width: "" },
      ],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      userMess: this.$store.state.user.user,

    };
  },
  computed: {},
  watch: {},
  methods: {
    getList() {

      this.$api.getMyHallList({ volunteerId: this.userMess.id }).then(res => {
        // console.log(res.data)
        this.tableData = res.data.rows
        this.total = res.data.total
      })

    },
    getDialog(params) {
      // console.log(params)
      let reqParams = {
        exhibitionHallId: params.toString(),
        volunteerId: this.userMess.id
      }
      // console.log(reqParams)
      this.$api.applyUnlock(reqParams).then(res => {
        // console.log(res)
        if (res.code == 0) {
          let _this = this
          this.$mess({
            title: "确认",
            content: res.message,
            head: '您不满足申请解锁资格！',
            confirm: true,
            // cancel: true,
            dialogVisible: true,
            btn: {
              confirmVal: "确定",
              // cancelVal: "取消"
            }
          }).then((res) => {
            // console.log("yes", res);
            //点击确定之后的处理
          }).catch((err) => {
            // console.log("no", err);
          });
        } else {
          this.$message.success(res.message);
        }
      })
      // this.dialogVisible = false
    },
    closeDialog() {
      this.dialogVisible = false
    },
    detail(row, column, event) {
      this.$router.push({ name: 'myHallDetail', params: { id: row.exhibitionHallId } })
      // console.log(row, column, event)
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
      // console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
      // console.log(`当前页: ${val}`);
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.getList();
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { } //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="less" scoped></style>
